var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.7202373%",
    y1: "41.6070847%",
    x2: "18.306123%",
    y2: "65.5065085%",
    id: "linearGradient-9_1k7ha4jv-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797BEB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373080",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4-7",
    fill: "url(#linearGradient-9_1k7ha4jv-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2746711,0 C12.5125388,0 12.7434104,0.12583746 12.8693403,0.33556656 L14.2545696,2.71249636 L20.3971523,2.71249636 C20.63502,2.71249636 20.8658915,2.83833382 20.9918215,3.04806292 L22.7338523,6.02621614 C22.8597822,6.23594524 22.8597822,6.5016021 22.7338523,6.7113312 L22.6988718,6.76725896 C22.6708873,6.80920478 22.6359068,6.8511506 22.5939301,6.88610545 L21.2156969,9.24905331 L24.2659999,14.4922808 L24.3429571,14.6041363 C24.4339065,14.8138654 24.4548948,15.0795223 24.3919298,15.2682785 L22.7898212,18.0087387 C22.6638912,18.2184678 22.4400158,18.3443053 22.195152,18.3443053 L19.4176972,18.3582872 L16.353402,23.6504515 C16.227472,23.8601806 16.0035966,23.9860181 15.7587328,23.9860181 L12.2886633,24 L12.2396906,24 C12.0158151,23.9860181 11.7989358,23.8601806 11.6869981,23.6644334 L10.1968271,21.1127294 L4.13120166,21.1127294 C4.0822289,21.1267113 4.04025225,21.1267113 3.9912795,21.1267113 C3.75341183,21.1267113 3.52254028,21.0008739 3.39661034,20.7911448 L1.79450165,18.0506845 C1.66857171,17.8479464 1.66857171,17.5892805 1.79450165,17.3725604 L3.17273489,14.9816487 L0.0944474553,9.69647539 C-0.0314824851,9.49373726 -0.0314824851,9.23507137 0.0944474553,9.0183513 L1.80849387,6.02621614 C1.92043159,5.81648704 2.15130315,5.69064958 2.40316303,5.69064958 C2.466128,5.67666764 2.51510075,5.69064958 2.56407351,5.70463152 L5.40449327,5.70463152 L8.44080406,0.46140402 C8.45479628,0.4194582 8.46179238,0.38450335 8.48278071,0.35653947 L8.49677292,0.33556656 C8.62270286,0.12583746 8.84657831,0 9.09144209,0 L12.2816672,0 L12.2746711,0 Z M9.04246933,0.72706088 L5.74730256,6.41071949 L2.3751786,6.41071949 L8.93752771,17.6871541 L5.59338819,17.6871541 L3.97728728,20.4765511 L10.5606247,20.4765511 L12.2396906,23.3708127 L18.8020397,12.0664142 L20.4811056,14.9466939 L23.7203035,14.9327119 L20.4181406,9.24905331 L22.0832143,6.38275561 L9.00049268,6.39673755 L10.6795586,3.51645791 L9.04946544,0.72706088 L9.04246933,0.72706088 Z M16.1435187,9.82930382 L12.2187023,16.5755899 L8.2938858,9.82930382 L16.1435187,9.82930382 Z",
    id: "_\\u5F62\\u72B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwenLogo);
export default __webpack_public_path__ + "static/media/qwen-logo.4524826d534773d971ce14fcfe01417b.svg";
export { ForwardRef as ReactComponent };